export default "__VITE_ASSET__guDRYUrv__"